/* eslint-disable jsx-a11y/anchor-has-content,max-len */
import React from 'react';
import { translate } from 'react-i18next';
import Col from 'react-bootstrap/lib/Col';
import Grid from 'react-bootstrap/lib/Grid';
import Image from 'react-bootstrap/lib/Image';
import Row from 'react-bootstrap/lib/Row';

import I18nLink, { patchTo } from 'widgets/I18nLink';
import Copyright from 'widgets/Copyright';

import logoImg from 'images/logo.png';
import masterCardVisaImg from './mastercard-visa.png';
import nortonSecuredImg from './norton-secured.png';
import './footer.css';

const COMPACT_PATHNAMES = [
  /\/detail\/\d+\//
];

const SEO_PATHNAMES = [
  /^(?:\/\w\w)?\/?$/,
  /^(?:\/\w\w)?\/about_us\/?$/,
  /^(?:\/\w\w)?\/.+-(on|in)-.+\/?$/, // city pages
  /^(?:\/\w\w)?\/contacts\/form\/?$/
];

const NavBLock = ({ t }) => (
  <div className="footer-nav-block">
    <Grid>
      <Row>
        <Col md={3} smHidden xsHidden>
          <I18nLink className="footer-logo" to="/">
            <Image
              alt="bikesbooking.com"
              src={logoImg}
              width={516}
              height={74}
              responsive
            />
          </I18nLink>
          <p>{t('Online reservation service for motorcycle, scooter, ATV and bicycle rental. We guarantee high level of service, best available rates and real reviews. Don\'t wait - book your bike today directly from providers in 41 countries.')}</p>
        </Col>

        <Col md={3} sm={4} xs={12}>
          <h5>{t('Information')}</h5>
          <ul>
            <li><I18nLink to="/about_us/">{t('About Us')}</I18nLink></li>
            <li><I18nLink to="/contacts/form/">{t('Contact Us')}</I18nLink></li>
            {/*
            <li><a href="#">{t('Press Centre')}</a></li>
            */}
          </ul>
        </Col>

        <Col md={3} sm={4} xs={12}>
          <h5>{t('For clients')}</h5>
          <ul>
            <li><I18nLink to="/faq/">{t('FAQ')}</I18nLink></li>
            <li><I18nLink to="/terms_and_conditions/">{t('Terms and Conditions')}</I18nLink></li>
            <li><I18nLink to="/privacy_policy/">{t('Privacy and Cookies')}</I18nLink></li>
            {/*
            <li><a href="#">{t('Best offers')}</a></li>
            */}
          </ul>
        </Col>

        <Col md={3} sm={4} xs={12}>
          <h5>{t('For companies')}</h5>
          <ul>
            <li><I18nLink to="/companies/register/">{t('Add your Rental company')}</I18nLink></li>
            <li><I18nLink to="/accounts/register/">{t('Login for company')}</I18nLink></li>
            <li><I18nLink to="/faq-for-companies/">{t('FAQ')}</I18nLink></li>
            <li><I18nLink to="/api-and-affiliate-partner-program/">{t('Affiliate program')}</I18nLink></li>
          </ul>
        </Col>
      </Row>
    </Grid>
  </div>
);

const ConnectBlock = ({
  t,
  config
}) => {
  const socials = config ? [
    [config.facebookUrl, 'Facebook', 'fb'],
    [config.twitterUrl, 'Twitter', 'tw'],
    [config.instagramUrl, 'Instagram', 'in'],
    [config.vkUrl, 'VK', 'vk']
  ] : [];

  return (
    <div className="footer-connect-block">
      <Grid>
        <Row>
          <Col
            className="footer-payment-methods-col"
            md={6}
            sm={4}
            xs={12}
          >
            <img
              alt="mastercard visa"
              className="lazyload footer-mastercard-visa-img"
              data-src={masterCardVisaImg}
              height={82}
              width={312}
            />

            <img
              alt="norton secured"
              className="lazyload footer-norton-secured-img"
              data-src={nortonSecuredImg}
              height={59}
              width={110}
            />
          </Col>

          <Col
            md={6}
            sm={8}
            xs={12}
            className="footer-socials-col"
          >
            {t('Join us')}:
            {!!config && (
              <ul className="footer-social-links-list">
                {socials.map(([url, label, key]) => (
                  <li key={key}>
                    <a
                      aria-label={`${t('BikesBooking on')} ${label}`}
                      className={`footer-social-link ${key}`}
                      href={url}
                      rel="noopener noreferrer"
                      target="_blank"
                      title={`${t('BikesBooking on')} ${label}`}
                    />
                  </li>
                ))}
              </ul>
            )}
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

const SeoBlock = ({ t }) => (
  <div className="footer-seo-block">
    <Grid>
      <Row>
        <Col md={3} sm={4}>
          <ul>
            <li><a href={patchTo('/rent-a-bicycle-in-Barcelona/')}>{t('Bicycle rental')} {t('in Barcelona')}</a></li>
            <li><a href={patchTo('/rent-a-bicycle-in-Alicante/')}>{t('Bicycle rental')} {t('in Alicante')}</a></li>
            <li><a href={patchTo('/rent-a-bicycle-in-Malaga/')}>{t('Rent a bicycle')} {t('in Malaga')}</a></li>
            <li><a href={patchTo('/rent-a-bicycle-in-Madrid/')}>{t('Bicycle rental')} {t('in Madrid')}</a></li>
            <li><a href={patchTo('/rent-a-bicycle-in-Rome/')}>{t('Bicycle rental')} {t('in Rome')}</a></li>
            <li><a href={patchTo('/rent-a-bicycle-in-Amsterdam/')}>{t('Rent a bicycle')} {t('in Amsterdam')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Santorini/')}>{t('Scooter rental')} {t('on Santorini')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-on-Zakynthos/')}>{t('Scooter rental')} {t('on Zakynthos')}</a></li>
          </ul>
        </Col>
        <Col md={3} sm={4}>
          <ul>
            <li><a href={patchTo('/rent-a-motorcycle-in-Barcelona/')}>{t('Motorcycle rental')} {t('in Barcelona')}</a></li>
            <li><a href={patchTo('/rent-a-motorcycle-in-Nice/')}>{t('Motorcycle rental')} {t('in Nice')}</a></li>
            <li><a href={patchTo('/rent-a-motorcycle-in-Paris/')}>{t('Motorcycle rental')} {t('in Paris')}</a></li>
            <li><a href={patchTo('/rent-a-motorcycle-in-Milano/')}>{t('Motorcycle rental')} {t('in Milano')}</a></li>
            <li><a href={patchTo('/top-10-best-motorcycle-rentals-on-Sardinia/')}>{t('Motorcycle rental')} {t('on Sardinia')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Valencia/')}>{t('Scooter rental')} {t('in Valencia')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Lisbon/')}>{t('Scooter rental')} {t('in Lisbon')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-on-the-azores-islands-portugal/')}>{t('Scooter rental')} {t('on Azores')}</a></li>
          </ul>
        </Col>
        <Col md={3} sm={4}>
          <ul>
            <li><a href={patchTo('/rent-a-scooter-in-Barcelona/')}>{t('Scooter rental')} {t('in Barcelona')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Alicante/')}>{t('Scooter rental')} {t('in Alicante')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Benidorm/')}>{t('Scooter rental')} {t('in Benidorm')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Menorca/')}>{t('Scooter rental')} {t('on Menorca')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Mallorca-(Majorca)/')}>{t('Scooter rental')} {t('on Mallorca')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-on-Ibiza/')}>{t('Scooter rental')} {t('on Ibiza')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Malaga/')}>{t('Rent a scooter')} {t('in Malaga')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Crete/')}>{t('Scooter rental')} {t('on Crete')}</a></li>
          </ul>
        </Col>
        <Col md={3} sm={4}>
          <ul>
            <li><a href={patchTo('/bike-and-scooter-rentals-in-sorrento-positano-amalfi/')}>{t('Rent a scooter')} {t('in Sorrento')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Milano/')}>{t('Scooter rental')} {t('in Milano')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Rome/')}>{t('Scooter rental')} {t('in Rome')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Tenerife/')}>{t('Scooter rental')} {t('on Tenerife')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Gran-Canaria/')}>{t('Scooter rental')} {t('on Gran Canaria')}</a></li>
            <li><a href={patchTo('/rent-a-scooter-in-Nice/')}>{t('Scooter rental')} {t('on Nice')}</a></li>
            <li><a href={patchTo('/rent-a-quad-bike-in-Santorini/')}>{t('Quad bike ATV rental')} {t('on Santorini')}</a></li>
            <li><a href={patchTo('/rent-a-quad-bike-in-Zakynthos-(Zante)/')}>{t('Quad bike ATV rental')} {t('on Zakynthos')}</a></li>
          </ul>
        </Col>
      </Row>
    </Grid>
  </div>
);

const CreditsBlock = ({ t }) => (
  <div className="footer-credits-block">
    <Copyright />

    <I18nLink to="/sitemap/" className="footer-sitemap-link">
      {t('Sitemap')}
    </I18nLink>
  </div>
);

const TranslatedComponents = {
  NavBLock: translate(['translation'])(NavBLock),
  ConnectBlock: translate(['translation'])(ConnectBlock),
  SeoBlock: translate(['translation'])(SeoBlock),
  CreditsBlock: translate(['translation'])(CreditsBlock)
};

const Footer = ({
  config,
  location
}) => {
  const { pathname } = location;

  let compact = false;

  for (let regex of COMPACT_PATHNAMES) {
    if (regex.test(pathname)) {
      compact = true;
      break;
    }
  }

  let showSeoBlock = false;

  for (let regex of SEO_PATHNAMES) {
    if (regex.test(pathname)) {
      showSeoBlock = true;
      break;
    }
  }

  return (
    <div className="footer">
      {!compact && (
        <TranslatedComponents.NavBLock />
      )}

      {!compact && (
        <TranslatedComponents.ConnectBlock config={config} />
      )}

      {(!compact && showSeoBlock) && (
        <TranslatedComponents.SeoBlock />
      )}

      <TranslatedComponents.CreditsBlock />
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js